module.exports = __webpack_public_path__ + "img/tractor-variant.e5a634d0.png";